import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import {
  APP_ACCESS_BLOCKED,
  EMPLOYEE_OVER_LIMIT,
  readApiErrorCode,
} from '../services/subscription/app-access-error-codes';
import { AppAccessRuntimeService } from '../services/subscription/app-access-runtime.service';

export const appAccessBlockInterceptor: HttpInterceptorFn = (req, next) => {
  const runtime = inject(AppAccessRuntimeService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const errorCode = readApiErrorCode(error);
      if (error.status === 403 && errorCode === APP_ACCESS_BLOCKED) {
        runtime.block('appNotGranted');
      } else if (error.status === 403 && errorCode === EMPLOYEE_OVER_LIMIT) {
        runtime.block('employeeOverLimit');
      }
      return throwError(() => error);
    }),
  );
};
